export enum ProjectStatusType {
  SCHEME = "SCHEME",
  IMPORT = "IMPORT",
  RUNNING = "RUNNING",
  PARTIAL_DISPATCHED = "PARTIAL_DISPATCHED",
  DISPATCHED = "DISPATCHED"
}
